"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactLenis } from "lenis/react";
import { useReducedMotion } from "framer-motion";
import { type ReactNode } from "react";
import { useAnchorScroll } from "./use-anchor-scroll";

// Renders nothing — just wires up the centered #anchor scrolling behaviour.
const AnchorScroll = () => {
  useAnchorScroll();
  return null;
};

// Wraps the page in Lenis for momentum/inertia smooth scrolling.
export const SmoothScroll = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const reduce = useReducedMotion();
  if (reduce) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <AnchorScroll />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== children) {
      t2 = <>{t1}{children}</>;
      $[1] = children;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      lerp: 0.1,
      smoothWheel: true,
      anchors: false
    };
    t2 = <AnchorScroll />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children) {
    t3 = <ReactLenis root={true} options={t1}>{t2}{children}</ReactLenis>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};